var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisitorsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9856 6.48548C4.66687 8.80423 4.66687 12.5362 4.66687 20C4.66687 27.464 4.66687 31.1959 6.9856 33.5147C9.30435 35.8334 13.0363 35.8334 20.5002 35.8334C27.9642 35.8334 31.696 35.8334 34.0148 33.5147C36.3335 31.1959 36.3335 27.464 36.3335 20C36.3335 12.5362 36.3335 8.80423 34.0148 6.48548C31.696 4.16675 27.9642 4.16675 20.5002 4.16675C13.0363 4.16675 9.30435 4.16675 6.9856 6.48548ZM20.5002 28.3334C22.3412 28.3334 23.8335 26.841 23.8335 25C23.8335 23.1592 22.3412 21.6667 20.5002 21.6667C18.6593 21.6667 17.1668 23.1592 17.1668 25C17.1668 26.841 18.6593 28.3334 20.5002 28.3334Z",
    fill: "#2C8C53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0002 21.6667L28.8335 15M23.8335 25.0001C23.8335 26.8409 22.341 28.3334 20.5002 28.3334C18.6592 28.3334 17.1669 26.8409 17.1669 25.0001C17.1669 23.1591 18.6592 21.6667 20.5002 21.6667C22.341 21.6667 23.8335 23.1591 23.8335 25.0001Z",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20C10.5 14.4771 14.9771 10 20.5 10C22.3215 10 24.0292 10.487 25.5 11.3378",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 20.0001C4.66675 12.5362 4.66675 8.80423 6.98548 6.48548C9.30423 4.16675 13.0362 4.16675 20.5001 4.16675C27.964 4.16675 31.696 4.16675 34.0147 6.48548C36.3335 8.80423 36.3335 12.5362 36.3335 20.0001C36.3335 27.464 36.3335 31.196 34.0147 33.5147C31.696 35.8335 27.964 35.8335 20.5001 35.8335C13.0362 35.8335 9.30423 35.8335 6.98548 33.5147C4.66675 31.196 4.66675 27.464 4.66675 20.0001Z",
    stroke: "#172B4D",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitorsIcon);
export default __webpack_public_path__ + "static/media/visitors_icon.d785f07312d3a2e5eed2a39253741256.svg";
export { ForwardRef as ReactComponent };